<template>
  <div class="analytics-chart" role="img" :aria-label="label" />
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'AnalyticsChart',
  props: { option: { type: Object, required: true }, label: { type: String, required: true } },
  watch: { option: { handler() { this.updateChart() }, deep: false } },
  mounted() {
    // 生产环境仍使用 ECharts 4.1.0，其 SVG 文字渲染会报错，统一使用 Canvas 保证图表完整显示。
    this.chart = echarts.init(this.$el, null, { renderer: 'canvas' })
    this.updateChart()
    this.resizeChart = () => {
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame)
      this.resizeFrame = requestAnimationFrame(() => { if (this.chart) this.chart.resize() })
    }
    window.addEventListener('resize', this.resizeChart)
    // 侧栏折叠也会改变容器宽度，不能只监听浏览器窗口。
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(this.resizeChart)
      this.observer.observe(this.$el)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame)
    if (this.observer) this.observer.disconnect()
    if (this.chart) this.chart.dispose()
    this.chart = null
  },
  methods: {
    updateChart() {
      if (this.chart) this.chart.setOption({ animation: false, ...this.option }, true)
    }
  }
}
</script>

<style scoped>
.analytics-chart { width: 100%; height: 100%; min-height: 140px; }
</style>
